import { createFileRoute } from '@tanstack/react-router'

import OrderResultPage from '@/views/orders/pages/orders-result.page'

export const Route = createFileRoute('/phong-nha/orders/result')({
  component: OrderResultPage,
})

